import { render, staticRenderFns } from "./gianfranco-soldera.vue?vue&type=template&id=6e8ce855&scoped=true"
import script from "./gianfranco-soldera.vue?vue&type=script&lang=js"
export * from "./gianfranco-soldera.vue?vue&type=script&lang=js"
import style0 from "./gianfranco-soldera.vue?vue&type=style&index=0&id=6e8ce855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ce855",
  null
  
)

export default component.exports